// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "2dae0a6d9f601aa2401b9e7e5a6ac144",
  base: "https://api.openweathermap.org/data/2.5/",
};
